import { del_mask } from '@/utils';
import { Getters } from 'vuex-smart-module';
import { Organizations } from '../types';
import OrganizationState from './state';

export default class OrganizationGetters extends Getters<OrganizationState> {
  get filtered_organizations() {
    return this.state.organizations.filter((curr_item: Organizations.Organization) => {
      const filter_city = this.state.filters.city;
      const org_type_filter = this.state.filters.organization_type;
      const { search = '' } = this.state.filters;
      let check = false;

      if (!search || !search.trim()) {
        check = true;
      } else {
        const str = search.trim().toLowerCase();
        const inn = del_mask(curr_item?.inn_organization?.toLowerCase()) || '';
        const kpp = del_mask(curr_item?.kpp_organization?.toLowerCase()) || '';
        const code = curr_item?.code?.toLowerCase() || '';
        const is_valid = [
          inn,
          kpp,
          code,
        ].some((el) => el.includes(str));

        if (!is_valid) {
          return false;
        }
        check = true;
      }

      if (filter_city === '' || filter_city === null) {
        check = true;
      } else if (curr_item?.city === filter_city) {
        check = true;
      } else {
        return false;
      }

      const org_type = typeof curr_item.organization_type === 'object' ? curr_item.organization_type.slug : curr_item.organization_type;

      if (org_type_filter?.length) {
        const check_org = org_type_filter.some((type) => org_type === type);

        if (!check_org) {
          return false;
        }
        check = true;
      } else {
        check = true;
      }

      return check;
    });
  }
}
